import React from "react";
import { useDispatch } from "react-redux";
import { setContextMenuOpened } from "../actions/contextMenuActions";

export const viewportContext = React.createContext({});

export const ViewportProvider = ({children}) => {
    const [outerWidth, setOuterWidth] = React.useState(window.outerWidth);
    const [innerWidth, setInnerWidth] = React.useState(window.innerWidth);
    const [outerHeight, setOuterHeight] = React.useState(window.outerHeight);
    const [innerHeight, setInnerHeight] = React.useState(window.innerHeight);

    const dispatch = useDispatch();

    const handleWindowResize = () => {
        setOuterWidth(window.outerWidth);
        setInnerWidth(window.innerWidth);
        setOuterHeight(window.outerHeight);
        setInnerHeight(window.innerHeight);

        dispatch(setContextMenuOpened(false));
    }

    React.useEffect(() => {
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    // eslint-disable-next-line
    }, []);

    return (
        <viewportContext.Provider value={{
            width: innerWidth, 
            height: innerHeight, 
            outerWidth: outerWidth, 
            innerWidth: innerWidth,
            outerHeight: outerHeight,
            innerHeight: innerHeight
        }}>
            {children}
        </viewportContext.Provider>
    )
}